<template>
  <el-dialog
      class="dialog-mobile"
      title="实名认证"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
  >
    <el-form ref="form" :model="formData" label-width="150px" :rules="rules">
      <el-form-item label="请输入真实姓名" prop="realname">
        <el-input type="text" v-model="formData.realname" placeholder="与身份证一致"></el-input>
      </el-form-item>

      <el-form-item label="请输入密码" prop="password">
        <el-input type="password" v-model="formData.password" placeholder="请输入登录密码进行验证"></el-input>
      </el-form-item>

      <el-form-item label="请输入身份证号码" prop="idcard">
        <el-input type="text" v-model="formData.idcard" placeholder="请输入18位身份证号"></el-input>
      </el-form-item>

      <el-form-item label="身份证照片" required>
        <el-upload
            class="upload-demo"
            :action="action"
            :on-preview="handlePreview"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :on-error="onError"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture"
            :limit="1"
            accept=".jpeg,.jpg,.png"
        >
          <el-button size="mini" type="primary">上传身份证正面</el-button>
          <div slot="tip" class="el-upload__tip">
            支持jpg、png格式、大小不超过5MB
          </div>
        </el-upload>

        <el-upload
            style="margin-top: 10px;"
            class="upload-demo"
            :action="action"
            :on-preview="handlePreview2"
            :before-upload="beforeUpload2"
            :on-success="onSuccess2"
            :on-error="onError2"
            :on-remove="handleRemove2"
            :file-list="fileList2"
            list-type="picture"
            :limit="1"
            accept=".jpeg,.jpg,.png"
        >
          <el-button size="mini" type="primary">上传身份证背面</el-button>
          <div slot="tip" class="el-upload__tip">
            支持jpg、png格式、大小不超过5MB
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="" prop="agree">
        <el-checkbox v-model="formData.agree" label="我已经阅读并同意"></el-checkbox>
        <router-link class="noticerelname" to="/noticerelname" target="_blank">《实名认证须知》</router-link>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BASE_URL from "@/api/base.js";
import { certification } from "@/api";
// 1. 引入加密库
import CryptoJS from 'crypto-js';

// 2. AES 密钥 (必须与后端 MemberService 中的 AES_KEY 完全一致)
const AES_KEY = "xVjzymyDzUN8dk0W";

export default {
  name: "RealNameDialog",
  data() {
    return {
      action: BASE_URL + "/api/file/upload",
      dialogVisible: false,
      formData: {
        realname: '',
        password: '',
        idcard: '',
        frontimage: '',
        backimage: '',
        agree: false
      },
      rules: {
        realname: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        idcard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          // 可以加一个简单的前端长度校验，减轻后端压力
          { min: 15, max: 18, message: "身份证长度不正确", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        agree: [{ required: true, message: "请同意协议", trigger: "change" }]
      },
      fileList: [],
      fileList2: [],
    };
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        // 窗口打开时重置表单，避免显示上一次的数据
        this.$nextTick(() => {
          if (this.$refs["form"]) this.$refs["form"].resetFields();
          this.fileList = [];
          this.fileList2 = [];
          this.formData = {
            realname: '',
            password: '',
            idcard: '',
            frontimage: '',
            backimage: '',
            agree: false
          };
        });
      }
    },
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },

    // --- AES 加密方法 ---
    encryptByAES(message) {
      const key = CryptoJS.enc.Utf8.parse(AES_KEY);
      const srcs = CryptoJS.enc.Utf8.parse(message);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },

    // --- 上传相关逻辑 ---
    handleRemove(file, fileList) {
      this.formData.frontimage = '';
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    onSuccess(response, file, fileList) {
      const { result, code, message } = response;
      if (code === 200) {
        this.$set(this.formData, "frontimage", result);
        this.$message.success('正面上传成功');
      } else {
        this.$message.error(message || '上传失败');
        this.fileList = [];
      }
    },
    onError() {
      this.$message.error('文件上传失败，请检查网络');
    },

    handleRemove2(file, fileList) {
      this.formData.backimage = '';
    },
    handlePreview2(file) {
      console.log(file);
    },
    beforeUpload2(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    onSuccess2(response, file, fileList) {
      const { result, code, message } = response;
      if (code === 200) {
        this.$set(this.formData, "backimage", result);
        this.$message.success('背面上传成功');
      } else {
        this.$message.error(message || '上传失败');
        this.fileList2 = [];
      }
    },
    onError2() {
      this.$message.error('文件上传失败，请检查网络');
    },

    close() {
      this.dialogVisible = false;
    },

    // --- 提交逻辑 (含加密) ---
    confirmHandle() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 图片校验
          if (!this.formData.frontimage) {
            return this.$message.warning("请上传身份证正面");
          }
          if (!this.formData.backimage) {
            return this.$message.warning("请上传身份证背面");
          }
          if (!this.formData.agree) {
            return this.$message.warning("请阅读并同意《实名认证须知》");
          }

          // 3. 构建请求参数，加密敏感字段
          const reqData = {
            ...this.formData, // 复制姓名、图片地址等非敏感信息
            // ★★★ 加密身份证号
            idcard: this.encryptByAES(this.formData.idcard),
            // ★★★ 加密密码
            password: this.encryptByAES(this.formData.password)
          };

          certification(reqData).then((res) => {
            this.$message.success("提交成功，请等待审核");
            this.close();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dialog-mobile {
  .el-button {
    width: 120px;
    height: 40px;
    &:hover {
      background-color: $red;
      border-color: $red;
      color: #fff;
    }
  }
  .el-button--primary {
    background-color: $red;
    border-color: $red;
  }

  .el-input {
    width: 230px;
    .el-input__inner {
      width: 280px;
      height: 40px;
      border: 1px solid #efefef !important;
      border-radius: 3px;
    }
  }
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: $red;
      border-color: $red;
    }
    & + .el-checkbox__label {
      color: #606266;
    }
  }
  a.noticerelname {
    font-size: 13px;
    color: $red;
    margin-left: 5px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  /* 修复上传组件间距 */
  .upload-demo {
    margin-bottom: 10px;
  }
}
</style>
